var map = {
	"./app-icon-grid-bg.svg": 1973,
	"./arrow-right.svg": 78449,
	"./check-success.svg": 5915,
	"./checkmark-no-bg.svg": 15483,
	"./checkmark.svg": 77882,
	"./chevron-down.svg": 54970,
	"./chevron-right.svg": 40718,
	"./currency-dollar-circle.svg": 73053,
	"./custom.svg": 66270,
	"./dots-grip.svg": 99836,
	"./dots-horizontal.svg": 38288,
	"./dots-vertical.svg": 87425,
	"./edit-05.svg": 34860,
	"./eye-off.svg": 11999,
	"./eye.svg": 78439,
	"./field-invalid.svg": 93035,
	"./field-valid.svg": 69163,
	"./field-warning.svg": 77940,
	"./frameworks/angular.svg": 28988,
	"./frameworks/gatsby.svg": 74084,
	"./frameworks/javascript.svg": 41876,
	"./frameworks/nextjs.svg": 68908,
	"./frameworks/nodejs.svg": 12810,
	"./frameworks/nuxtjs.svg": 52015,
	"./frameworks/php.svg": 16651,
	"./frameworks/react.svg": 78623,
	"./frameworks/svelte.svg": 62982,
	"./frameworks/tailwind.svg": 21790,
	"./frameworks/tailwindcss.svg": 84666,
	"./frameworks/vuejs.svg": 32803,
	"./headless-storefront.svg": 89221,
	"./help-circle.svg": 76622,
	"./hosting/cloudflare.svg": 19656,
	"./hosting/heroku.svg": 2615,
	"./hosting/netlify.svg": 72386,
	"./hosting/other.svg": 39211,
	"./hosting/swell.svg": 11016,
	"./hosting/vercel.svg": 39185,
	"./info-error.svg": 33335,
	"./info.svg": 93733,
	"./libraries/builder.svg": 4843,
	"./libraries/tailwind.svg": 17062,
	"./lock.svg": 36158,
	"./migration/bigcommerce.svg": 29541,
	"./migration/magento.svg": 28939,
	"./migration/other.svg": 33057,
	"./migration/shopify.svg": 62348,
	"./migration/woocommerce.svg": 26230,
	"./monitor.svg": 17272,
	"./sandbox.svg": 98452,
	"./scan.svg": 73583,
	"./settings-01.svg": 47135,
	"./store.svg": 90908,
	"./storefront-app.svg": 20369,
	"./terminal-square.svg": 79805,
	"./theme.svg": 12300,
	"./themes/builder.svg": 63954,
	"./themes/shopify.svg": 16238,
	"./themes/swell.svg": 11695,
	"./themes/vercel.svg": 44654,
	"./unlock.svg": 74175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40682;